import { helper } from '@ember/component/helper';
import { GlyphIcon } from '@square/dashboard-protos/models/squareup/inflows/external_instant_access_service';
function getInstantAccessSvgName([num]) {
  switch (num) {
    case GlyphIcon.SQUARE_CARD:
      return '24px-debit-card';
    case GlyphIcon.BANK:
      return '24px-bank-stroked';
    case GlyphIcon.CHECKMARK_CIRCLE:
      return 'checkmark-circle';
    case GlyphIcon.DOORDASH:
      return 'doordash';
    case GlyphIcon.UBER_EATS:
      return 'uber-eats';
    case GlyphIcon.GRUBHUB:
      return 'grubhub';
    default:
      return '';
  }
}
export default helper(getInstantAccessSvgName);